import { AxiosHeaders } from "axios";
import { axiosInstance } from "../../../api/axiosInstance";
import { APIS, FEE_DUE_APIS } from "../../../modules/common/api/apis";
import { getAxiosHeaders } from "../../../modules/common/shared/AxiosAPI";
import { FeeDue, PreviousYearDueStudent } from "../types";

export const getFeeDues = async (grade: string, section: string, status: string, academicYear: string): Promise<FeeDue[]> => {
  let url = FEE_DUE_APIS.GET_FD_BY_GRADE_AND_SECTION_AND_TERMS_AND_STATUS.replace("gradeName_value", grade)
    .replace("section_value", section)
    .replace("terms_value", "4") //If we do not pass this we will get wrong values
    .replace("status_value", status); // === "true" ? "true" : "false"

  const response = await axiosInstance.get<FeeDue[]>(url);
  return response.data;
};

export const getFeeDuesByStudent = async (admissionNo: string): Promise<FeeDue[]> => {
  const url = APIS.FEE_DUE_DATA_FOR_STUDENT_BY_ADMISSION_NO;
  let currHeaders: AxiosHeaders = getAxiosHeaders();
  currHeaders.set("admissionNo", admissionNo);
  const response = await axiosInstance.get<FeeDue[]>(url, { headers: currHeaders });
  return response.data;
};

export const getPreviousYearDues = async (): Promise<PreviousYearDueStudent[]> => {
  const response = await axiosInstance.get<PreviousYearDueStudent[]>(FEE_DUE_APIS.GET_PREVIOUS_YEAR_DUES);
  return response.data;
};
